import momentTz from "moment-timezone";

const momentPhoenix = (toConvert) => {
  let phx = momentTz(toConvert).tz("America/Phoenix");
  return phx;
};

export default momentPhoenix;
